import { Icon, IconName, useDeviceTypes } from "halifax";
import { Box, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import { RouteComponentProps } from "react-router-dom";
import { AncillaryKindEnum } from "redmond";
import config from "b2b-base/src/utils/config";
import { isCorpTenant } from "@capone/common";
import { CfarCancellationPolicyConnectorProps } from "./container";
import {
  CFAR_POLICY_SUBTITLE,
  CFAR_POLICY_TITLE,
  getCancellationPolicyInfoV2,
} from "./constants";

export interface ICfarCancellationPolicyProps
  extends RouteComponentProps,
    CfarCancellationPolicyConnectorProps {}

export const CfarCancellationPolicy = (props: ICfarCancellationPolicyProps) => {
  const {
    hotelCfarQuote,
    isCfarQuoteV2Enabled,
    hotelCfarQuoteV2,
    additionalInfo,
    addedAncillary,
    offerAmountToApply,
  } = props;
  const addedCfar = addedAncillary.find(
    (ancillary) => ancillary.kind === AncillaryKindEnum.Cfar
  );
  const tenant = config.TENANT;
  const cancellationPolicyInfoV2 = getCancellationPolicyInfoV2({
    additionalInfo: isCfarQuoteV2Enabled
      ? undefined
      : additionalInfo ?? undefined,
    hotelCfarQuote: isCfarQuoteV2Enabled ? hotelCfarQuoteV2 : undefined,
    addedCfar,
    offerAmountToApply,
  });
  const title =
    cancellationPolicyInfoV2?.primaryText ??
    CFAR_POLICY_TITLE(hotelCfarQuote?.coveragePercentage);
  const subtitle =
    cancellationPolicyInfoV2?.secondaryText ??
    CFAR_POLICY_SUBTITLE(hotelCfarQuote?.coveragePercentage);
  const { matchesMobile } = useDeviceTypes();

  const hideIcon = isCorpTenant(tenant) && matchesMobile;

  return (
    <Box
      className={clsx(
        "checkout-template-card-content-container",
        "cancellation-details"
      )}
    >
      <Typography variant="h2">
        {!hideIcon && <Icon name={IconName.CheckShieldBlue} />}
        <span
          className={clsx("cancellation-details-title", {
            padding: isCorpTenant(tenant),
          })}
        >
          {title}
        </span>
      </Typography>
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: subtitle,
        }}
      />
    </Box>
  );
};
